<template>
  <div>
    <div class="fontMono">
      <div class="table-container">
        <table cellspacing="0" style="width:100%; border-collapse: collapse;">
          <tr>
            <td colspan="4" style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">
              <span>
                <strong style="font-size: 30px;">{{empresa.nombrec}}</strong>
                
                <small style="color: #7a7a7a; font-size: 20px;"
                >Nit: {{empresa.nit | textnumber()}}{{empresa.nit | dverif()}}</small>
              </span>
              <span style="font-size: 15px;">{{empresa.nombre}}</span>
            </td>
            <td colspan="3" style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right;">
              <span style="font-size: 30px;">{{data.comprobante.prefijo}} {{total.documento}}</span>
            </td>
          </tr>
          <tr>
            <td colspan="7" style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">{{empresa.ciudad}} {{empresa.direccion}} Tel: {{empresa.telefono}}</td>
          </tr>
          <tr>
            <td colspan="4" style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">
              <strong style="font-size: 30px;"
              >{{data.comprobante.titulo ? data.comprobante.titulo : data.comprobante.nombre}}</strong>
            </td>
            <td colspan="3" style="text-align:right; border: 1px solid #dbdbdb; !important; padding: 5px !important;">
              <h3 class="title is-4">{{total.fecha | date()}}</h3>
            </td>
          </tr>
          <tr  style="background-color: #f5f5f5;">
            <th style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">#</th>
            <th style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">Cuenta</th>
            <th style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">Tercero</th>
            <th style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">Concepto</th>
            <th style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">Ref</th>
            <th style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">Ccostos</th>
            <th style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">Valor</th>
          </tr>
          <tr v-for="(registro, index) in registros" :key="index">
            <td style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">{{index+1}}</td>
            <td style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">
              <small>{{registro.idcuenta.codigo}}</small>
              {{registro.idcuenta.nombre}}
            </td>
            <td style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">
              {{registro.idnit.nombre == 'NA' ? '' : registro.idnit.nombre}}
              <small>{{registro.idnit.nombre == 'NA' ? '' : registro.idnit.codigo}}</small>
            </td>
            <td style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">{{registro.descripcion}}</td>
            <td style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">{{registro.docRef}}</td>
            <td style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">{{registro.ccostos}}</td>
            <td
              style="border: 1px solid #dbdbdb; !important; padding: 5px !important; text-align:right; "
            >{{total.tipo == registro.tipo ? '-' : ''}}{{registro.valor | number(2)}}</td>
          </tr>
          <tr style="background-color: #f5f5f5;">
            <td style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">
              <strong>T</strong>
            </td>
            <td style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">
              <strong>
                <small>{{total.idcuenta.codigo}}</small>
                {{total.idcuenta.nombre}}
              </strong>
            </td>
            <td style="border: 1px solid #dbdbdb; !important; padding: 5px !important;"> 
              {{total.idnit.nombre == 'NA' ? '' : total.idnit.nombre }}
              <small>{{total.idnit.nombre == 'NA' ? '' : total.idnit.codigo}}</small>
            </td>
            <td style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">{{total.descripcion}}</td>
            <td style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">{{total.docRef}}</td>
            <td style="border: 1px solid #dbdbdb; !important; padding: 5px !important;">{{total.ccostos}}</td>
            <td style="border: 1px solid #dbdbdb; !important; padding: 5px !important;font-size: 20px; text-align:right;">
              <strong>{{total.valor | number(2)}}</strong>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="fontMono">
      Firma y Sello del Beneficiario
      <br />
      <br />
      <br />
      <br />________________________________
      <br />C.C.
      <br />
      <br />
      {{data.comprobante.mensaje}}
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    data: Object,
    total: Object,
    registros: Array
  },
  computed: {
    ...mapState(["empresa"])
  }
};
</script>


// WEBPACK FOOTER //
// src/components/prints/Printcomercial.vue